import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_activity_grid_ComponentContextService } from './FootprintManager.activity_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Inspections_task_date_types_dd_singleComponent } from './Inspections.task_date_types_dd_single.component'


interface IFootprintManager_activity_gridComponentEntity {
  Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, ModifiedSysUser?: string, Notes?: string, SerialNumberId?: number, ActualPackagedPack?: { ShortName?: string }, ExpectedPackagedPack?: { ShortName?: string }, Lot?: { Id?: number, LookupCode?: string, Material?: { ProjectId?: number, Project?: { Id?: number, LookupCode?: string } } }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { Id?: number, LookupCode?: string } }, Project?: { Id?: number, LookupCode?: string }, OperationCode?: { Name?: string }, Status?: { Name?: string }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string }, ActualSourceLocation?: { Id?: number, Name?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string }, ActualTargetLocation?: { Id?: number, Name?: string }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string }, ExpectedTargetLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedTargetLocation?: { Id?: number, Name?: string }, Warehouse?: { Name?: string }, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string }, SerialNumber?: { LookupCode?: string }}

interface IFootprintManager_activity_gridComponentInParams {
  project_ids?: number[], owner_ids?: number[], warehouse_ids?: number[], operation_code_ids?: number[], status_ids?: number[], location_id?: number, seven_days_before_flag?: boolean}


class FootprintManager_activity_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_activity_gridComponent;
  entity: IFootprintManager_activity_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    warehouse: null,
    operation_code: null,
    status: null,
    material_lookupcode: null,
    lot: null,
    project: null,
    serialnumber: null,
    actual_packaged_amount: null,
    actual_packaging: null,
    expected_packaged_amount: null,
    expected_packaging: null,
    created_date: null,
    completed_date: null,
    user: null,
    actual_source_licenseplate: null,
    actual_source_location: null,
    actual_target_licenseplate: null,
    actual_target_location: null,
    expected_source_licenseplate: null,
    expected_source_location: null,
    expected_target_licenseplate: null,
    expected_target_location: null,
    order_lookupcode: null,
    order_owner_reference: null,
    order_vendor_reference: null,
    notes: null,
  }



  constructor(
    grid: FootprintManager_activity_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_activity_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.operation_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.operation_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.serialnumber = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.serialnumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.expected_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.expected_packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.completed_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.completed_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.order_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_owner_reference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.order_owner_reference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_vendor_reference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.order_vendor_reference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_activity_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_activity_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      project_ids:  $grid.inParams.project_ids ,
      owner_ids:  $grid.inParams.owner_ids ,
      warehouse_ids:  $grid.inParams.warehouse_ids ,
      operation_code_ids:  $grid.inParams.operation_code_ids ,
      status_ids:  $grid.inParams.status_ids ,
      from_date:  $grid.filters.from_date.control.value ,
      to_date:  $grid.filters.to_date.control.value ,
      date_type:  $grid.filters.date_type.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
      ids:  null ,
      location_id:  $grid.inParams.location_id ,
    };
    const data = await this.$datasources.FootprintManager.ds_activity_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_activity_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse.Name;
    (this.cells.operation_code.displayControl as TextModel).text = $row.entity.OperationCode?.Name;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Project?.LookupCode ?? $row.entity.Material?.Project?.LookupCode ?? $row.entity.Lot?.Material?.Project?.LookupCode;
    (this.cells.serialnumber.displayControl as TextModel).text = $row.entity.SerialNumber?.LookupCode;
    (this.cells.actual_packaged_amount.displayControl as TextModel).text = $row.entity.ActualPackagedAmount?.toString();
    (this.cells.actual_packaging.displayControl as TextModel).text = $row.entity.ActualPackagedPack?.ShortName;
    (this.cells.expected_packaged_amount.displayControl as TextModel).text = $row.entity.ExpectedPackagedAmount?.toString();
    (this.cells.expected_packaging.displayControl as TextModel).text = $row.entity.ExpectedPackagedPack?.ShortName;
    (this.cells.user.displayControl as TextModel).text = $row.entity.ModifiedSysUser;
    (this.cells.actual_source_licenseplate.displayControl as TextModel).text = $row.entity.ActualSourceLicensePlate?.LookupCode;
    (this.cells.actual_source_location.displayControl as TextModel).text = $row.entity.ActualSourceLocation?.Name;
    (this.cells.actual_target_licenseplate.displayControl as TextModel).text = $row.entity.ActualTargetLicensePlate?.LookupCode;
    (this.cells.actual_target_location.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.expected_source_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedSourceLicensePlate?.LookupCode;
    (this.cells.expected_source_location.displayControl as TextModel).text = $row.entity.ExpectedSourceLocation?.Name;
    (this.cells.expected_target_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedTargetLicensePlate?.LookupCode;
    (this.cells.expected_target_location.displayControl as TextModel).text = $row.entity.ExpectedTargetLocation?.Name;
    (this.cells.order_lookupcode.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.order_owner_reference.displayControl as TextModel).text = $row.entity.Order?.OwnerReference;
    (this.cells.order_vendor_reference.displayControl as TextModel).text = $row.entity.Order?.VendorReference;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'Id' : {
        this.on_task_id_clicked();
        break;
      }
      case 'material_lookupcode' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'project' : {
        this.on_project_clicked();
        break;
      }
      case 'serialnumber' : {
        this.on_serialnumber_clicked();
        break;
      }
      case 'actual_source_licenseplate' : {
        this.on_actual_source_lp_clicked();
        break;
      }
      case 'actual_source_location' : {
        this.on_actual_source_location_clicked();
        break;
      }
      case 'actual_target_licenseplate' : {
        this.on_actual_target_lp_clicked();
        break;
      }
      case 'actual_target_location' : {
        this.on_actual_target_location_clicked();
        break;
      }
      case 'expected_source_licenseplate' : {
        this.on_expected_source_lp_clicked();
        break;
      }
      case 'expected_source_location' : {
        this.on_expected_source_location_clicked();
        break;
      }
      case 'expected_target_licenseplate' : {
        this.on_expected_target_lp_clicked();
        break;
      }
      case 'expected_target_location' : {
        this.on_expected_target_location_clicked();
        break;
      }
      case 'order_lookupcode' : {
        this.on_order_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  if ($utils.isDefined($row.entity.CreatedSysDateTime) && $utils.isDefined($settings.FootprintManager.DateFormat) && $utils.isDefined($settings.FootprintManager.TimeFormat)) {
      var dateFormat = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`
      var createdDate = $utils.date.format($row.entity.CreatedSysDateTime, dateFormat);
      $row.cells.created_date.displayControl.text = createdDate;
  }
  
  
  if ($utils.isDefined($row.entity.CompletedDateTime) && $utils.isDefined($settings.FootprintManager.DateFormat) && $utils.isDefined($settings.FootprintManager.TimeFormat)) {
      var dateFormat = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`
      var completedDate = $utils.date.format($row.entity.CompletedDateTime, dateFormat);
      $row.cells.completed_date.displayControl.text = completedDate;
  }
  
  
  
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Material?.Id)) {
      $shell.FootprintManager.opensingle_material_hub({ materialId: $row.entity.Material.Id });
  }
  
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if($utils.isDefined($row.entity?.Lot?.Id))
  {
      $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.Lot.Id});
  } 
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Project?.Id)|| $utils.isDefined($row.entity?.Material?.ProjectId) || $utils.isDefined($row.entity.Lot?.Material?.ProjectId)) {
      const projectId = $utils.isDefined($row.entity?.Project?.Id) ? $row.entity.Project.Id :
          ($utils.isDefined($row.entity?.Material?.ProjectId) ? $row.entity.Material.ProjectId : $row.entity.Lot?.Material?.ProjectId);
  
      if ($utils.isDefined(projectId)) {
          $shell.FootprintManager.opensingle_project_hub({ projectId: projectId });
      }
  }
  }
  on_actual_source_lp_clicked(event = null) {
    return this.on_actual_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_lp_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualSourceLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualSourceLicensePlate.Id });
  }
  }
  on_actual_target_lp_clicked(event = null) {
    return this.on_actual_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_lp_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualTargetLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualTargetLicensePlate.Id });
  }
  }
  on_expected_source_lp_clicked(event = null) {
    return this.on_expected_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_lp_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ExpectedSourceLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedSourceLicensePlate.Id });
  }
  }
  on_expected_target_lp_clicked(event = null) {
    return this.on_expected_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_lp_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedTargetLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedTargetLicensePlate.Id });
  }
  }
  on_actual_source_location_clicked(event = null) {
    return this.on_actual_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_location_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualSourceLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualSourceLocation.Id });
  }
  }
  on_actual_target_location_clicked(event = null) {
    return this.on_actual_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_location_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualTargetLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualTargetLocation.Id });
  }
  }
  on_expected_source_location_clicked(event = null) {
    return this.on_expected_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_location_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ExpectedSourceLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedSourceLocation.Id });
  }
  }
  on_expected_target_location_clicked(event = null) {
    return this.on_expected_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_location_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedTargetLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedTargetLocation.Id });
  }
  }
  on_serialnumber_clicked(event = null) {
    return this.on_serialnumber_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_serialnumber_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.SerialNumberId)) {
      $shell.FootprintManager.opensingle_serialnumber_hub({ serialnumberId: $row.entity.SerialNumberId });
  }
  }
  on_task_id_clicked(event = null) {
    return this.on_task_id_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_task_id_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  let result = await $shell.FootprintManager.opentask_details_editorDialog({ taskId: $row.entity.Id, is_non_editable: true }, 'flyout');
  
  }
  on_order_clicked(event = null) {
    return this.on_order_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_order_clickedInternal(
    $row: FootprintManager_activity_gridComponentRowModel,
  $grid: FootprintManager_activity_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  if ($utils.isDefined($row.entity.Order?.Id)) {
  
      // Check order class type
      const order = (await $datasources.PurchaseOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Order?.Id })).result;
      if ($utils.isDefined(order)) {
          const orderClassTypeId = order.OrderClass.OrderClassTypeId;
          if (orderClassTypeId == 1) {
              $shell.FootprintManager.openpurchase_order_editor({ orderId: $row.entity.Order.Id });
          }
          else if (orderClassTypeId == 12) {
              $shell.FootprintManager.openasn_order_editor({ order_id: $row.entity.Order.Id });
          }
          else if (orderClassTypeId == 5) {
              $shell.FootprintManager.opensales_order_editor({ orderId: $row.entity.Order.Id });
          }
          else {
              throw new Error('Editor for selected order class type under development!')
          }
  
      }
  }
  
  
  
  
  
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Inspections_task_date_types_dd_singleComponent),
  ],
  selector: 'FootprintManager-activity_grid',
  templateUrl: './FootprintManager.activity_grid.component.html'
})
export class FootprintManager_activity_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_activity_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_activity_gridComponentInParams = { project_ids: [], owner_ids: [], warehouse_ids: [], operation_code_ids: [], status_ids: [], location_id: null, seven_days_before_flag: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       operation_code: new GridHeaderModel(new HeaderStyles(null, null), 'operation_code', 'Operation code', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'material_lookupcode', 'Material', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       serialnumber: new GridHeaderModel(new HeaderStyles(null, null), 'serialnumber', 'Serial number', false, false, null, false),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaged_amount', 'Actual', false, false, null, false),       actual_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaging', 'Actual packaging', false, false, null, false),       expected_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'expected_packaged_amount', 'Expected', false, false, null, false),       expected_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'expected_packaging', 'Expected packaging', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created date', false, false, null, false),       completed_date: new GridHeaderModel(new HeaderStyles(null, null), 'completed_date', 'Completed date', false, false, null, false),       user: new GridHeaderModel(new HeaderStyles(null, null), 'user', 'User', false, false, null, false),       actual_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_licenseplate', 'Actual source LP', false, false, null, false),       actual_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_location', 'Actual source loc', false, false, null, false),       actual_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_licenseplate', 'Actual target LP', false, false, null, false),       actual_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_location', 'Actual target loc', false, false, null, false),       expected_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_licenseplate', 'Expected source LP', false, false, null, false),       expected_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_location', 'Expected source loc', false, false, null, false),       expected_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_licenseplate', 'Expected target LP', false, false, null, false),       expected_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_location', 'Expected target loc', false, false, null, false),       order_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'order_lookupcode', 'Order', false, false, null, false),       order_owner_reference: new GridHeaderModel(new HeaderStyles(null, null), 'order_owner_reference', 'Order reference', false, false, null, false),       order_vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'order_vendor_reference', 'Order PO', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_activity_gridComponentRowModel[] = [];

  @Input('project_ids') set $inParams_project_ids(value: any) {
    this.inParams['project_ids'] = value;
  }
  get $inParams_project_ids(): any {
    return this.inParams['project_ids'] ;
  }
  @Input('owner_ids') set $inParams_owner_ids(value: any) {
    this.inParams['owner_ids'] = value;
  }
  get $inParams_owner_ids(): any {
    return this.inParams['owner_ids'] ;
  }
  @Input('warehouse_ids') set $inParams_warehouse_ids(value: any) {
    this.inParams['warehouse_ids'] = value;
  }
  get $inParams_warehouse_ids(): any {
    return this.inParams['warehouse_ids'] ;
  }
  @Input('operation_code_ids') set $inParams_operation_code_ids(value: any) {
    this.inParams['operation_code_ids'] = value;
  }
  get $inParams_operation_code_ids(): any {
    return this.inParams['operation_code_ids'] ;
  }
  @Input('status_ids') set $inParams_status_ids(value: any) {
    this.inParams['status_ids'] = value;
  }
  get $inParams_status_ids(): any {
    return this.inParams['status_ids'] ;
  }
  @Input('location_id') set $inParams_location_id(value: any) {
    this.inParams['location_id'] = value;
  }
  get $inParams_location_id(): any {
    return this.inParams['location_id'] ;
  }
  @Input('seven_days_before_flag') set $inParams_seven_days_before_flag(value: any) {
    this.inParams['seven_days_before_flag'] = value;
  }
  get $inParams_seven_days_before_flag(): any {
    return this.inParams['seven_days_before_flag'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    from_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    to_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    from_date: new FieldModel(new DateBoxModel(this.formGroup.controls['from_date'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'From date', false, false),
    to_date: new FieldModel(new DateBoxModel(this.formGroup.controls['to_date'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'To date', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_activity_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Activity Grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;

    (this.filters.date_type.control as SelectBoxModel).reset('CreatedSysDateTime');

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      project_ids:  $grid.inParams.project_ids ,
      owner_ids:  $grid.inParams.owner_ids ,
      warehouse_ids:  $grid.inParams.warehouse_ids ,
      operation_code_ids:  $grid.inParams.operation_code_ids ,
      status_ids:  $grid.inParams.status_ids ,
      from_date:  $grid.filters.from_date.control.value ,
      to_date:  $grid.filters.to_date.control.value ,
      date_type:  $grid.filters.date_type.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
      ids:  null ,
      location_id:  $grid.inParams.location_id ,
    };
    try {
      const data = await this.$datasources.FootprintManager.ds_activity_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_activity_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_activity_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_activity_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: FootprintManager_activity_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  const settingsExcelExportLimit = $settings.FootprintManager.ExcelExportLimit;
  const serverMaxAllowedRecordsLimit: number = 5000;// could be changed base on what each request to the server can handle.
  const concurrentLimit = 5;//max concurrent requests
  const timeout = 500;//use it only if you want to set a delay between requests...
  // Initialize
  var workBook = $event;
  var recordsToExport = [];
  var fullDataSet: any[] = [];
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  //parameters to be passed to dataset api call
  const baseParams = {
          project_ids: $grid.inParams.project_ids,
          owner_ids: $grid.inParams.owner_ids,
          warehouse_ids: $grid.inParams.warehouse_ids,
          operation_code_ids: $grid.inParams.operation_code_ids,
          status_ids: $grid.inParams.status_ids,
          from_date: $grid.filters.from_date.control.value,
          to_date: $grid.filters.to_date.control.value,
          date_type: $grid.filters.date_type.control.value,
          fullTextSearch: $grid.fullTextSearch,
          location_id: $grid.inParams.location_id
  };
  
  //api call
  const dataApiCall = async (baseParams: any) => {
      return await $datasources.FootprintManager.ds_activity_grid.getList(baseParams);
  };
  
  //records count api call
  const countApiCall = async (baseParams: any) => {
      const params = { ...baseParams, $top: 0 };
      return await $datasources.FootprintManager.ds_activity_grid.getList(params);
  };
  
  //api call execution
  async function processApiCall(apiCall: (params: any) => Promise<any>, baseParams: any = {}, offset: number = 0, limit: number = 0): Promise<any> {
      const defaultParams = { $skip: offset, $top: limit };
      // Merge base, default, and additional params
      const params = { ...baseParams, ...defaultParams };
      return await apiCall(params);
  };
  
  //main funcion to handle concurrency in reagard of server and request limits
  async function processControlledApiRequests(totalRecords: number, requestLimit: number, serverLimit: number): Promise<any[]> {
      const totalBatches = Math.ceil(Math.min(totalRecords, serverLimit) / requestLimit);
  
      const result: any[] = [];
      const fetchPromiseQueue: Promise<any[]>[] = [];
  
      for (let i = 0; i < totalBatches; i++) {
          const offset = i * requestLimit;
          const limit = Math.min(requestLimit, serverLimit - (i * requestLimit));
  
          fetchPromiseQueue.push(processApiCall(dataApiCall, baseParams, offset, limit));
  
          //process promiseQueue once reached the limit then clear queue for the next loop round...
          if (fetchPromiseQueue.length === concurrentLimit) {
              result.push(...await Promise.all(fetchPromiseQueue));
              fetchPromiseQueue.length = 0;
          }
      }
  
      // Process any remaining requests after the loop
      if (fetchPromiseQueue.length) result.push(...await Promise.all(fetchPromiseQueue));
  
      return result;
  }
  
  // Set Date/Time Formats
  const dateFormat = `${$settings.FootprintManager.DateFormat}`;
  
  function getAge(date: any): number {
      var diffInDays: number;
      if ($utils.isDefined(date)) {
          const currentDate = new Date();
          const receiveDate = new Date(date);
          const diffInMS = currentDate.getTime() - receiveDate.getTime();
          diffInDays = Math.floor(diffInMS / (1000 * 60 * 60 * 24));
      }
      return diffInDays;
  }
  
  try {
      //Handle user selected rows only.
      if ($grid.selectedRows?.length > 0) {
          // Compile all data into JSON
          for (let row of $grid.selectedRows) {
              recordsToExport.push({
                  "Id": row?.entity?.Id,
                  "Warehouse": row?.entity?.Warehouse?.Name,
                  "Operationcode": row?.entity?.OperationCode?.Name,
                  "Status": row?.entity?.Status?.Name,
                  "Material": row?.entity?.Material?.LookupCode,
                  "Lot": row?.entity?.Lot?.LookupCode,
                  "Project": row?.entity?.Project?.LookupCode,
                  "SerialNumber": row?.entity?.SerialNumber?.LookupCode,
                  "Actual": row?.entity?.ActualPackagedAmount,
                  "ActualPackaging": row?.entity?.ActualPackagedPack?.ShortName,
                  "Expected": row?.entity?.ExpectedPackagedAmount,
                  "ExpectedPackaging": row?.entity?.ExpectedPackagedPack?.ShortName,
                  "CreatedDate": row?.entity?.CreatedSysDateTime,
                  "CompletedDate": row?.entity?.CompletedDateTime,
                  "User": row?.entity?.ModifiedSysUser,
                  "ActualSourceLp": row?.entity?.ActualSourceLicensePlate?.LookupCode,
                  "ActualSourceLoc": row?.entity?.ActualSourceLocation?.Name,
                  "ActualTargetLp": row?.entity?.ActualTargetLicensePlate?.LookupCode,
                  "ActualTargetLoc": row?.entity?.ActualTargetLocation?.Name,
                  "ExpectedSourceLp": row?.entity?.ExpectedSourceLicensePlate?.LookupCode,
                  "ExpectedsourceLoc": row?.entity?.ExpectedSourceLocation?.Name,
                  "ExpectedTargetLp": row?.entity?.ExpectedTargetLicensePlate?.LookupCode,
                  "ExpectedTargetLoc": row?.entity?.ExpectedTargetLocation?.Name,
                  "Order": row?.entity?.Order?.LookupCode,
                  "OrderReference": row?.entity?.Order?.OwnerReference,
                  "OrderPo": row?.entity?.Order?.VendorReference,
                  "Notes": row?.entity?.Notes
              });
          }
          var workSheet = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, workSheet, "DockAppointmentsExport");
      }
      //take all rows in the dataset with applied filters.
      else {
          //using confirmation logic to make sure customer intend to export the records
          //const confirm = await $shell.FootprintManager.openConfirmationDialog(`Export records...`, `Are you sure you want to export grid records?`, 'Yes', 'No');
          //if (confirm) {
  
          const { totalCount: requestedRecordsCount } = await countApiCall(baseParams);
  
          if (requestedRecordsCount > settingsExcelExportLimit) {
              await $shell.FootprintManager.openInfoDialog(`Export limitation of ${settingsExcelExportLimit} exceeded`, `Excel will only export ${settingsExcelExportLimit} records`);
          }
  
          const responses = await processControlledApiRequests(requestedRecordsCount, serverMaxAllowedRecordsLimit, settingsExcelExportLimit);
          responses.forEach(apiResponse => {
              fullDataSet.push(...apiResponse.result);
          });
  
  
          // Compile all data into JSON
          for (let record of fullDataSet) {
              recordsToExport.push({
                  "Id": record?.Id,
                  "Warehouse": record?.Warehouse?.Name,
                  "Operationcode": record?.OperationCode?.Name,
                  "Status": record?.Status?.Name,
                  "Material": record?.Material?.LookupCode,
                  "Lot": record?.Lot?.LookupCode,
                  "Project": record?.Project?.LookupCode,
                  "SerialNumber": record?.SerialNumber?.LookupCode,
                  "Actual": record?.ActualPackagedAmount,
                  "ActualPackaging": record?.ActualPackagedPack?.ShortName,
                  "Expected": record?.ExpectedPackagedAmount,
                  "ExpectedPackaging":record?.ExpectedPackagedPack?.ShortName,
                  "CreatedDate": record?.CreatedSysDateTime,
                  "CompletedDate": record?.CompletedDateTime,
                  "User": record?.ModifiedSysUser,
                  "ActualSourceLp": record?.ActualSourceLicensePlate?.LookupCode,
                  "ActualSourceLoc": record?.ActualSourceLocation?.Name,
                  "ActualTargetLp": record?.ActualTargetLicensePlate?.LookupCode,
                  "ActualTargetLoc": record?.ActualTargetLocation?.Name,
                  "ExpectedSourceLp": record?.ExpectedSourceLicensePlate?.LookupCode,
                  "ExpectedsourceLoc": record?.ExpectedSourceLocation?.Name,
                  "ExpectedTargetLp": record?.ExpectedTargetLicensePlate?.LookupCode,
                  "ExpectedTargetLoc": record?.ExpectedTargetLocation?.Name,
                  "Order": record?.Order?.LookupCode,
                  "OrderReference": record?.Order?.OwnerReference,
                  "OrderPo": record?.Order?.VendorReference,
                  "Notes": record?.Notes
              });
          }
          var workSheet = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, workSheet, "DockAppointmentsExport");
  
      }
  } catch (error) {
      //apparantly the code in here is just for any issues could happen with the code of the functions 
      //but not working for catching errors related the workbook itself
      //so if we commented this code will get a General Error message says "workbook is empty"
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
  
      throw new Error(errorMessage);
  
  
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_activity_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_activity_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if($grid.inParams.seven_days_before_flag){
      const today = new Date();
      const sevenDaysBefore = new Date(today);
      sevenDaysBefore.setDate(today.getDate() - 7);
  
      $grid.filters.from_date.control.value = sevenDaysBefore;
  }
  
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'FootprintManager_activity_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
